import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ApiEndpoints } from '@app/utils/enums/api-endpoints';
import {
  SignUpFormDataRequest,
  SignUpFormResponse,
} from '@app/utils/interfaces/sign-up-form.interface';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SignUpService {
  private readonly baseUrl = environment.apiBaseUrl;
  private readonly http = inject(HttpClient);

  signUpUser(data: SignUpFormDataRequest): Observable<SignUpFormResponse> {
    return this.http.post<SignUpFormResponse>(`${this.baseUrl}${ApiEndpoints.SIGN_UP}`, data);
  }
}
